import { Table } from '@zillow/constellation-10';
import { LoadingText } from '@zg-rentals/loading-components';

const hiddenBelow = {
  sm: { display: { base: 'none', sm: 'table-cell' } },
  lg: { display: { base: 'none', lg: 'table-cell' } },
  xl: { display: { base: 'none', xl: 'table-cell' } },
  xxl: { display: { base: 'none', xxl: 'table-cell' } },
} as const;

type Props = {
  showAddressColumn?: boolean;
};

export const TasksTableSkeleton = ({ showAddressColumn = true }: Props) => {
  return (
    <>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Name</Table.HeaderCell>
          {showAddressColumn && <Table.HeaderCell css={hiddenBelow.lg}>Property address</Table.HeaderCell>}
          <Table.HeaderCell css={hiddenBelow.sm}>Status</Table.HeaderCell>
          <Table.HeaderCell css={hiddenBelow.xl}>Last updated</Table.HeaderCell>
          <Table.HeaderCell css={hiddenBelow.xxl}>Cost</Table.HeaderCell>
          <Table.HeaderCell css={{ width: '0' }} aria-label="Actions">
            {' '}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {Array.from({ length: 5 }).map((_, rowIdx) => (
          <Table.Row key={`loading-row-${rowIdx}`} interactive={true} css={{ '& td': { paddingBlock: 'default' } }}>
            <Table.Cell>
              <LoadingText isLoading={true} loadingWidth="90%" textStyle="body-sm">
                Loading
              </LoadingText>
            </Table.Cell>
            {showAddressColumn && (
              <Table.Cell css={hiddenBelow.lg}>
                <LoadingText isLoading={true} loadingWidth="100%" textStyle="body-sm">
                  Loading address
                </LoadingText>
              </Table.Cell>
            )}
            <Table.Cell css={hiddenBelow.sm}>
              <LoadingText isLoading={true} loadingWidth="80%" textStyle="body-sm">
                Loading
              </LoadingText>
            </Table.Cell>
            <Table.Cell css={hiddenBelow.xl}>
              <LoadingText isLoading={true} loadingWidth="75%" textStyle="body-sm">
                Loading
              </LoadingText>
            </Table.Cell>
            <Table.Cell css={hiddenBelow.xxl}>
              <LoadingText isLoading={true} loadingWidth="50%" textStyle="body-sm">
                Loading
              </LoadingText>
            </Table.Cell>
            <Table.Cell css={{ width: '0' }}> </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </>
  );
};
